"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isRequired = function (value, required) {
    return !required || value !== "";
};
var isEmail = function (value) {
    return /^([a-zA-Z0-9_\-.+]+)@([a-zA-Z0-9_\-.]+).([a-zA-Z]{2,5})$/.test(value);
};
var isMinLength = function (value, length) {
    if (!length)
        return true;
    return value.length >= length;
};
var isPattern = function (value, pattern) {
    return new RegExp(pattern).test(value);
};
var validations = {
    required: isRequired,
    email: isEmail,
    minLength: isMinLength,
    pattern: isPattern,
};
exports.default = validations;
//# sourceMappingURL=validations.js.map